export default function buildUrl(urlTemplate, page) {
  return urlTemplate.replace('{{ page }}', page.toString());
}